import type { VoidFunctionComponent } from 'react';

import { SNIPPET_DETECTION } from '../../../../../shared/featureFlags/flagNames';
import { FeatureFlagRequired } from '../../../generic';
import Header from '../../../shared/settings/SettingsPageHeader';
import OrganizationSettingsPermissionGate from '../../OrganizationSettingsPermissionGate';
import { shouldDisplayProjectGeneralSettings } from '../../shared/permissions';

import GithubStatusCheckSection from './GithubStatusCheckSection';
import PrivacySection from './PrivacySection';
import SnippetsSection from './SnippetsSection';

/**
 * SettingsOrganizationProjectGeneral is the settings page for managing
 * the global project settings.
 */
const SettingsOrganizationProjectGeneral: VoidFunctionComponent = () => {
  return (
    <>
      <Header heading="Default General Settings" />
      <PrivacySection />
      <GithubStatusCheckSection />
      <FeatureFlagRequired flagName={SNIPPET_DETECTION}>
        <SnippetsSection />
      </FeatureFlagRequired>
    </>
  );
};

/**
 * SettingsOrganizationProjectGeneralContainer displays the project general settings page if the user has permission to view it.
 */
const SettingsOrganizationProjectGeneralContainer: VoidFunctionComponent = () => (
  <OrganizationSettingsPermissionGate checkPermission={shouldDisplayProjectGeneralSettings}>
    <SettingsOrganizationProjectGeneral />
  </OrganizationSettingsPermissionGate>
);

export default SettingsOrganizationProjectGeneralContainer;
